module.exports = __webpack_public_path__ + "pf.1398e1c8.svg";